
import { Component, VModel } from 'vue-property-decorator';
import Page from '@/Page.vue';
import PermissionsOverview from '@/libs/settings/components/PermissionsOverview.vue';
import { TenantUserModel, TenantModel } from '@/libs/Api';
import { authStore } from '@/libs/auth/+store/store';
import { AuthGetter } from '@/libs/auth/models/auth-state';

@Component({
    components: {
        PermissionsOverview,
    },
})
export default class MyPermissionsDialog extends Page {
    @VModel() innerValue!: boolean;

    get tenantUser(): TenantUserModel | null {
        return authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
    }

    get currentTenant(): TenantModel | null {
        return authStore.useGetter(AuthGetter.GetTenant) as TenantModel;
    }

    get tenantName(): string {
        // Zkusíme získat název z různých zdrojů
        if (this.currentTenant?.name) {
            return this.currentTenant.name;
        }
        if (this.tenantUser?.tenant?.name) {
            return this.tenantUser.tenant.name;
        }
        // Fallback z URL nebo localStorage
        const urlParams = new URLSearchParams(window.location.search);
        const tenantId = urlParams.get('tenantId') || window.localStorage.getItem('tenantId');
        if (tenantId) {
            // Můžeme zobrazit ID jako fallback
            return `Tenant: ${tenantId}`;
        }
        return '–';
    }

    close() {
        this.innerValue = false;
    }
}
